const screenWidth = window.screen.availWidth;
export const isExtraSmallScreen = screenWidth <= 360;
export const isSmallScreen = screenWidth > 360 && screenWidth <= 767; //tab
export const isMediumScreen = screenWidth > 767 && screenWidth < 1124;
export const isLargeScreen = screenWidth >= 1124;

export const EXTRA_SMALL_SCREEN = "extraSmall"; // xs
export const SMALL_SCREEN = "small"; // sm
export const MEDIUM_SCREEN = "medium"; // med
export const LARGE_SCREEN = "large"; // large

const getScreenSize = () => {
  let screenSize = LARGE_SCREEN;
  if (isExtraSmallScreen) {
    screenSize = EXTRA_SMALL_SCREEN;
  } else if (isSmallScreen) {
    screenSize = SMALL_SCREEN;
  } else if (isMediumScreen) {
    screenSize = MEDIUM_SCREEN;
  } else if (isLargeScreen) {
    screenSize = LARGE_SCREEN;
  }
  return screenSize;
};
export const screenSize = getScreenSize();
export const isMobile = screenSize === SMALL_SCREEN || screenSize === EXTRA_SMALL_SCREEN;
export const isIpad = !isMobile && screenSize === MEDIUM_SCREEN
export const isDesktop = !isMobile && screenSize === LARGE_SCREEN


export const generateWidthByscreenSize = () => {

  let widthSize = '250px'

  if (screenWidth >= 1124 && screenWidth <= 1298) {
    return '320px'
  }
  if (screenWidth >= 1299 && screenWidth <= 1599) {
    return '260px'
  }
  if (screenWidth >= 1600 && screenWidth <= 1799) {
    return '300px'
  }
  if (screenWidth >= 1800 && screenWidth <= 1899) {
    return '260px'
  }
  if (screenWidth >= 1900 && screenWidth <= 1999) {
    return '310px'
  }
  if (screenWidth >= 2000 && screenWidth <= 2099) {
    return '326px'
  }
  if (screenWidth >= 2100 && screenWidth <= 2200) {
    return '346px'
  }
  if (screenWidth >= 768 && screenWidth <= 821) {
    return '200px'
  }
  return widthSize
}